import React from 'react'
import { Helmet } from 'react-helmet'

import { buildImageObj } from '../../lib/helpers'
import { imageUrlFor } from '../../lib/image-url'
import useMeta from '../../lib/useMeta'

const SEO = ({ data, location }) => {
  console.log(data)
  const { siteUrl } = useMeta()
  const canonical = '' + siteUrl + location.pathname
  const imgUrl = data.ogImage
    ? imageUrlFor(buildImageObj(data.ogImage)).width(1200).height(628).url()
    : null

  return (
    <Helmet>
      <html lang="en-GB" />
      <title>{data.title}</title>
      <meta
        name="description"
        content={
          data.description ||
          'We are Active Matter: A design and innovation studio in the heart of Birmingham, England.'
        }
      />
      {data.noIndex && <meta name="robots" content="noindex,nofollow" />}

      <link rel="canonical" value={canonical} />
      <meta property="og:title" content={data.title} />
      <meta
        property="og:description"
        content={
          data.description ||
          'We are Active Matter: A design and innovation studio in the heart of Birmingham, England.'
        }
      />
      <meta property="og:url" content={canonical} />
      {data.ogImage && <meta property="og:image" content={imgUrl} />}
      {data.ogImage && <meta name="twitter:card" content={imgUrl}></meta>}
    </Helmet>
  )
}

export default SEO
